import * as React from 'react';
import { useRef } from 'react';
import { useCookieConsentContext, isCookieCategoryEnabled } from '@grandvisionhq/cookie-consent';

function getMaxDeliveryDate(maxDeliveryDays) {
    const date = new Date();
    date.setDate(date.getDate() + maxDeliveryDays);
    return date.toISOString().split('T')[0];
}
function TrustedShopsConfirmation({ order , currency  }) {
    var ref, ref1;
    // Load the trustbadge.reInitialize() after the load of the component
    React.useEffect(()=>{
        if (typeof window !== 'undefined' && typeof window.trustbadge !== 'undefined') {
            window.trustbadge.reInitialize();
        }
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        id: "trustedShopsCheckout",
        style: {
            display: 'none'
        }
    }, /*#__PURE__*/ React.createElement("span", {
        id: "tsCheckoutOrderNr"
    }, order.orderNumber), ((ref = order.customerDetails) === null || ref === void 0 ? void 0 : ref.email) && /*#__PURE__*/ React.createElement("span", {
        id: "tsCheckoutBuyerEmail"
    }, order.customerDetails.email), /*#__PURE__*/ React.createElement("span", {
        id: "tsCheckoutOrderAmount"
    }, order.totalPrice / 100), /*#__PURE__*/ React.createElement("span", {
        id: "tsCheckoutOrderCurrency"
    }, currency), /*#__PURE__*/ React.createElement("span", {
        id: "tsCheckoutOrderPaymentType"
    }, order.paymentMethod.label), ((ref1 = order.shippingInfo) === null || ref1 === void 0 ? void 0 : ref1.maxDeliveryDate) && /*#__PURE__*/ React.createElement("span", {
        id: "tsCheckoutOrderEstDeliveryDate"
    }, getMaxDeliveryDate(order.shippingInfo.maxDeliveryDate)));
}
function FooterTrustedShops({ divCSS  }) {
    return /*#__PURE__*/ React.createElement("div", {
        id: "trustbadgeCustomMobileContainer",
        style: divCSS
    });
}
function TrustedShops({ trustedShopsId , ScriptComponent , widgetStyle ={
    desktopYOffset: 0,
    mobileYOffset: 0,
    desktopDisableReviews: false,
    desktopEnableCustom: false,
    desktopPosition: 'left',
    desktopCustomWidth: 156,
    desktopEnableFadeout: false,
    disableMobile: false,
    disableTrustbadge: false,
    mobileDisableReviews: false,
    mobilePosition: 'center',
    mobileEnableTopbar: false,
    mobileEnableFadeout: true,
    colorScheme: 'light',
    mobileEnableCustom: true,
    mobileCustomWidth: 156
}  }) {
    const strategy = useRef('beforeInteractive');
    const consentResult = useCookieConsentContext();
    if (!isCookieCategoryEnabled('functional', consentResult)) {
        // the beforeInteractive strategy won't inject the script after effects
        strategy.current = 'afterInteractive';
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ScriptComponent, {
        strategy: strategy.current,
        src: `https://widgets.trustedshops.com/js/${trustedShopsId}.js`,
        "data-desktop-y-offset": widgetStyle.desktopYOffset,
        "data-mobile-y-offset": widgetStyle.mobileYOffset,
        "data-desktop-disable-reviews": widgetStyle.desktopDisableReviews,
        "data-desktop-enable-custom": widgetStyle.desktopEnableCustom,
        "data-desktop-position": widgetStyle.desktopPosition,
        "data-desktop-custom-width": widgetStyle.desktopCustomWidth,
        "data-desktop-enable-fadeout": widgetStyle.desktopEnableFadeout,
        "data-disable-mobile": widgetStyle.disableMobile,
        "data-disable-trustbadge": widgetStyle.disableTrustbadge,
        "data-mobile-disable-reviews": widgetStyle.mobileDisableReviews,
        "data-mobile-position": widgetStyle.mobilePosition,
        "data-mobile-enable-topbar": widgetStyle.mobileEnableTopbar,
        "data-mobile-enable-fadeout": widgetStyle.mobileEnableFadeout,
        "data-color-scheme": widgetStyle.colorScheme,
        "data-mobile-enable-custom": widgetStyle.mobileEnableCustom,
        "data-mobile-custom-width": widgetStyle.mobileCustomWidth
    }));
}
function TrustedShopsWidgetScript({ ScriptComponent  }) {
    const strategy = useRef('beforeInteractive');
    const consentResult = useCookieConsentContext();
    if (!isCookieCategoryEnabled('functional', consentResult)) {
        // the beforeInteractive strategy won't inject the script after effects
        strategy.current = 'afterInteractive';
        return null;
    }
    return /*#__PURE__*/ React.createElement(ScriptComponent, {
        strategy: strategy.current,
        src: "https://integrations.etrusted.com/applications/widget.js/v2"
    });
}
function TrustedShopsWidgetComponent({ id  }) {
    return /*#__PURE__*/ React.createElement("etrusted-widget", {
        "data-etrusted-widget-id": id
    });
}

export { FooterTrustedShops, TrustedShops, TrustedShopsConfirmation, TrustedShopsWidgetComponent, TrustedShopsWidgetScript, TrustedShops as default, getMaxDeliveryDate };
//# sourceMappingURL=TrustedShops.js.map
